import { render, staticRenderFns } from "./DatosCompradoresSgaComponent.vue?vue&type=template&id=0b611eb2&scoped=true"
import script from "./DatosCompradoresSgaComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./DatosCompradoresSgaComponent.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DatosCompradoresSgaComponent.vue?vue&type=style&index=0&id=0b611eb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b611eb2",
  null
  
)

export default component.exports